import { render } from "./CompSectionSheetComponent.vue?vue&type=template&id=90afab6a&scoped=true"
import script from "./CompSectionSheetComponent.vue?vue&type=script&lang=js"
export * from "./CompSectionSheetComponent.vue?vue&type=script&lang=js"

import "./CompSectionSheetComponent.vue?vue&type=style&index=0&id=90afab6a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90afab6a"]])

export default __exports__